import { ResolverTag } from '@ps/web-core-enums';
import { useNavigate } from '@ps/web-shared-components';
import React, { useState } from 'react';

import ResolverIframe from '@swf/components/Iframe/ResolverIframe';

import AMLSuspended from '../../../AMLSuspended/AMLSuspended';
import ButtonGroup from '../../../ButtonGroup/ButtonGroup';
import CTAButton from '../../../CTAButton/CTAButton';

import {
  TXTACL_Contact_us,
  TXTWCL_Back_to_homepage
} from './DepositAccountVerificationCSForm.messages.json';
import styles from './DepositAccountVerificationCSForm.scss';

const DepositAccountVerificationCSForm: React.FC = () => {
  const [showContactSupportForm, setShowContactSupportForm] = useState(false);
  const navigate = useNavigate();

  const onContactSupportClick = () => {
    setShowContactSupportForm(true);
  };

  return (
    <>
      {showContactSupportForm ? (
        <ResolverIframe
          scrolling="auto"
          tag={ResolverTag.VerifyMeAML}
          className={styles.contactSupportForm}
        />
      ) : (
        <>
          <AMLSuspended />
          <ButtonGroup>
            <CTAButton translation={TXTACL_Contact_us} onClick={onContactSupportClick} />
            <CTAButton
              translation={TXTWCL_Back_to_homepage}
              variant="secondary"
              // onClick={exitWizard}
              onClick={() => navigate('/')}
            />
          </ButtonGroup>
        </>
      )}
    </>
  );
};

export default DepositAccountVerificationCSForm;
